import axios from "axios";
import React from "react";
import { ButtonClean } from "../components";
import { STORE } from "../redux";
import { BASE_URL } from "../config/settings.json";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service

    console.log(error, errorInfo);

    let data = STORE.getState().profileReducer.profile;

    if (!data) {
      const listener = () => {
        data = STORE.getState().profileReducer.profile;
      };

      const unsubscribe = STORE.subscribe(listener);
      unsubscribe();
    }

    const userId = data?.sub || "";

    const body = {
      error: error.toString(),
      details: errorInfo.componentStack,
      user: userId,
      navigator: navigator.userAgent,
      location: window.location.href,
      date: new Date().toISOString(),
    };

    axios.post(`${BASE_URL}/logs/create-one`, body).catch((err) => console.error("Error reporting failed:", err));
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="Background_Gray pt-lg-5 py-2 error-boundary">
          <div className="container">
            <div className="row">
              <h3 className="mb-4" style={{ color: "white" }}>
                Oups, il semblerait que vous rencontriez un problème. Nous vous invitons à supprimer les caches de votre navigateur puis
                refaire votre demande ou d’utiliser la navigation privée puis refaire votre demande.
              </h3>

              <div className="my-5">
                <ButtonClean
                  message="Rafraîchir"
                  onClick={() => {
                    window.location.reload();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
